import createReducer from '../utils/base';

const INITIAL_STATE = {
  param: 'values',
};

export default createReducer(
    {
    }, INITIAL_STATE);
